import apiClient from './index';

// Authentication API endpoints
const authApi = {
  // Login user
  login: async (username, password) => {
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    
    const response = await apiClient.post('/adss/v1/auth/login', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  },
  
  // Register new user
  register: async (userData) => {
    const response = await apiClient.post('/adss/v1/users', userData);
    return response.data;
  },
  
  // Get current user profile
  getCurrentUser: async () => {
    const response = await apiClient.get('/adss/v1/users/me');
    return response.data;
  },
  
  // Update user profile
  updateProfile: async (userData) => {
    const response = await apiClient.patch('/adss/v1/users/me', userData);
    return response.data;
  },
  
  // Change user password
  changePassword: async (currentPassword, newPassword) => {
    const response = await apiClient.post('/adss/v1/users/me/change-password', {
      current_password: currentPassword,
      new_password: newPassword
    });
    return response.data;
  },
  
  // Request password reset
  requestPasswordReset: async (email) => {
    const response = await apiClient.post('/adss/v1/auth/reset-password/request', {
      email
    });
    return response.data;
  },
  
  // Verify password reset token
  verifyResetToken: async (token) => {
    const response = await apiClient.post('/adss/v1/auth/reset-password/verify', {
      token
    });
    return response.data;
  },
  
  // Reset password with token
  resetPassword: async (token, newPassword) => {
    const response = await apiClient.post('/adss/v1/auth/reset-password/confirm', {
      token,
      new_password: newPassword
    });
    return response.data;
  },
  
  // Get user by ID (admin only)
  getUserById: async (userId) => {
    const response = await apiClient.get(`/adss/v1/users/${userId}`, {
      params: { include_roles: true }
    });
    return response.data;
  },
  
  // Get all users (admin only)
  getUsers: async (skip = 0, limit = 100, search = '') => {
    const params = { skip, limit, include_roles: true };
    if (search && search.trim()) {
      params.search = search.trim();
    }
    
    const response = await apiClient.get('/adss/v1/users', {
      params
    });
    return response.data;
  },
  
  // Update user (admin only)
  updateUser: async (userId, userData) => {
    const response = await apiClient.patch(`/adss/v1/users/${userId}`, userData);
    return response.data;
  },

  // Generate password reset link for user (admin only)
  generatePasswordResetLink: async (userId) => {
    const response = await apiClient.post(`/adss/v1/users/${userId}/generate-reset-link`);
    return response.data;
  }
};

export default authApi;